import { c as _c } from "react/compiler-runtime";
import { Text, VStack } from '@chakra-ui/react';
import { SessionReviewCard } from '@src/components/sco/Advisors/reviews/SessionReviewCard';
import { sortSessionReviews, type SessionReviewItem } from '@src/components/sco/Advisors/reviews/sessionReviewHelpers';
import { AdvisorsLoadMore } from '@src/components/sco/Advisors/shared/AdvisorsLoadMore';
import { ReactNode } from 'react';
export type SessionReviewListProps = {
  /** `ScoUser.sessionReviews.items` (nulls are dropped). Rendered featured first, then newest. */
  reviews: Array<SessionReviewItem | null | undefined>;
  /** Shows the "Show more reviews" button. */
  hasMore?: boolean;
  loadingMore?: boolean;
  onShowMore?: () => void;
  /** Copy when there are no reviews. Pass null to render nothing instead. */
  emptyText?: string | null;
  /** Manage view: hidden markers + hidden text (see `SessionReviewCard`). */
  showManageState?: boolean;
  /** Per-review actions (manage view). */
  renderActions?: (review: SessionReviewItem) => ReactNode;
};
export const SessionReviewList = t0 => {
  const $ = _c(28);
  const {
    reviews,
    hasMore: t1,
    loadingMore: t2,
    onShowMore,
    emptyText: t3,
    showManageState: t4,
    renderActions
  } = t0;
  const hasMore = t1 === undefined ? false : t1;
  const loadingMore = t2 === undefined ? false : t2;
  const emptyText = t3 === undefined ? "No reviews yet." : t3;
  const showManageState = t4 === undefined ? false : t4;
  let T0;
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== emptyText || $[1] !== renderActions || $[2] !== reviews || $[3] !== showManageState) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const items = sortSessionReviews(reviews.filter(_temp));
      if (!items.length) {
        let t11;
        if ($[11] !== emptyText) {
          t11 = emptyText ? <Text color="fg.muted" fontSize="sm">{emptyText}</Text> : null;
          $[11] = emptyText;
          $[12] = t11;
        } else {
          t11 = $[12];
        }
        t10 = t11;
        break bb0;
      }
      T0 = VStack;
      t5 = "stretch";
      t6 = "section";
      t7 = 3;
      t8 = "full";
      let t11;
      if ($[13] !== renderActions || $[14] !== showManageState) {
        t11 = review_0 => <SessionReviewCard key={review_0.id} actions={renderActions?.(review_0)} review={review_0} showManageState={showManageState} />;
        $[13] = renderActions;
        $[14] = showManageState;
        $[15] = t11;
      } else {
        t11 = $[15];
      }
      t9 = items.map(t11);
    }
    $[0] = emptyText;
    $[1] = renderActions;
    $[2] = reviews;
    $[3] = showManageState;
    $[4] = T0;
    $[5] = t10;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    T0 = $[4];
    t10 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[16] !== hasMore || $[17] !== loadingMore || $[18] !== onShowMore) {
    t11 = onShowMore && <AdvisorsLoadMore hasNextPage={hasMore} label="Show more reviews" loading={loadingMore} onLoadMore={onShowMore} />;
    $[16] = hasMore;
    $[17] = loadingMore;
    $[18] = onShowMore;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== T0 || $[21] !== t11 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t12 = <T0 align={t5} as={t6} gap={t7} width={t8}>{t9}{t11}</T0>;
    $[20] = T0;
    $[21] = t11;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
function _temp(review) {
  return !!review;
}